import { SVGProps } from 'react';

export default function Minus(props: Partial<SVGProps<any>>) {
  return (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <rect y="7" width="16" height="2" rx="1" fill="#212021"/>
</svg>
    
  )
}